/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';

declare const MPFingerprint: any;

@Injectable({
  providedIn: 'root',
})
export class MonitorService {
  geoIp!: any;

  async getData(): Promise<any | null> {
    try {
      return await MPFingerprint.getData(true, true);
    } catch (error) {
      console.error('Error al obtener datos de fingerprint:', error);
      return Promise.resolve(null);
    }
  }

  startMonitorData(): Observable<any> {
    const monitorData = this.getData();

    return from(monitorData);
  }
}